import { Close } from "@mui/icons-material";
import {
  Button,
  IconButton,
  Modal,
  ModalProps,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import LoadingButton from "src/components/Buttons/LoadingButton";
import { useIsMobile } from "src/hooks/useIsMobile";
import { desktopSx, mobileSx } from "src/utils/styles/modalStyles";

type EditModalTypes = {
  open: boolean;
  onClose: (o: boolean) => void;
  title: string;
  subTitle?: string;
  loading: boolean;
  onSubmit: () => void;
} & ModalProps;

const EditModal = ({
  children,
  open,
  onClose,
  title,
  subTitle,
  loading,
  onSubmit,
}: EditModalTypes) => {
  const isMobile = useIsMobile();
  const page = "account.overview.editModal";
  const { t } = useTranslation();

  return (
    <Modal open={open} disableEnforceFocus>
      <Stack sx={isMobile ? mobileSx : desktopSx} gap={4}>
        <Stack>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="h6" fontWeight={600}>
              {title}
            </Typography>
            <IconButton onClick={(o) => onClose(!o)}>
              <Close />
            </IconButton>
          </Stack>
          <Typography variant="subtitle2">{subTitle}</Typography>
        </Stack>
        {children}
        <Stack direction="row" gap={1} justifyContent="flex-end">
          <Button
            variant="alternate"
            sx={{ background: "transparent", color: "#000000" }}
            size="large"
            onClick={(o) => onClose(!o)}
          >
            {t(`${page}.cancel`)}
          </Button>
          <LoadingButton
            loading={loading}
            onClick={onSubmit}
            size="large"
            sx={{ padding: "10px 20px 10px 20px" }}
          >
            {t(`${page}.submit`)}
          </LoadingButton>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default EditModal;
